/**
 * Button Component
 * Reusable button with multiple variants
 */

import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  fullWidth = false,
  className = '',
  type = 'button',
  onClick,
  ...props
}) => {
  const baseStyles = 'lh-btn inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'lh-btn--primary bg-primary-500 hover:bg-primary-600 text-white focus:ring-primary-500 hover:shadow-lg hover:-translate-y-0.5',
    secondary: 'lh-btn--secondary bg-secondary-500 hover:bg-secondary-600 text-white focus:ring-secondary-500 hover:shadow-lg hover:-translate-y-0.5',
    outline: 'lh-btn--outline border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white focus:ring-primary-500',
    ghost: 'lh-btn--ghost text-dark-600 hover:bg-dark-100 focus:ring-dark-300',
    danger: 'lh-btn--danger bg-red-500 hover:bg-red-600 text-white focus:ring-red-500 hover:shadow-lg',
    success: 'lh-btn--success bg-green-500 hover:bg-green-600 text-white focus:ring-green-500 hover:shadow-lg',
  };

  const sizes = {
    sm: 'lh-btn--sm px-3 py-1.5 text-sm',
    md: 'lh-btn--md px-5 py-2.5 text-base',
    lg: 'lh-btn--lg px-6 py-3 text-lg',
    xl: 'lh-btn--xl px-8 py-4 text-xl',
  };

  return (
    <button
      type={type}
      className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'lh-btn--full-width w-full' : ''}
        ${loading ? 'lh-btn--loading' : ''}
        ${disabled ? 'lh-btn--disabled' : ''}
        ${className}
      `}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && (
        <svg
          className="lh-btn__spinner animate-spin -ml-1 mr-2 h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="lh-btn__spinner-track opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="lh-btn__spinner-fill opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      <span className="lh-btn__content">{children}</span>
    </button>
  );
};

export default Button;
